/** 耀雪活动分包业务文案 — 中文 */
export default {
  activity: {
    yx: {
      nav: {
        home: '耀雪冰雪世界',
        rules: '耀雪活动细则',
      },
      share: {
        homeTitle: '免息购上海耀雪雪世界门票，最低198元起',
        rulesTitle: '上海耀雪雪世界活动细则',
      },
      product: {
        yuXue: '耀雪滑雪场-娱雪门票',
        huaXue: '耀雪滑雪场-滑雪门票',
      },
      home: {
        rulesBtn: '活动细则',
        cardYuXue: '娱雪项目',
        cardSki: '滑雪项目',
        priceFrom: '起',
        ticketYuXueTypes: '标准票/优待票',
        ticketSkiTypes: '初级道3小时标准票等',
        disclaimer: '下单前请看清购票对应权限以及有效时效，避免出现权益不对等无法使用、或时效过期的情况。',
        skiDesc0: '来耀雪，赴一场热血与畅快的冰雪之约！',
        skiDesc1: '驰骋雪道之上，乘风破雪自由滑行。',
        skiDesc2: '感受速度与激情，解锁滑雪无限乐趣。',
        yuXueDesc0: '走进冰雪世界，',
        yuXueDesc1: '乘雪国列车穿梭极光，',
        yuXueDesc2: '在雪地撒欢、冰上飞驰。',
        yuXueDesc3: '每一处都是欢乐，',
        yuXueDesc4: '每一瞬都藏着惊喜。',
        yuXueDesc5: '快来耀雪，',
        yuXueDesc6: '赴一场冬日浪漫与快乐之约！',
      },
      rules: {
        badge: '活动细则',
        tabs: {
          yuXue: '娱雪项目',
          ski: '滑雪项目',
        },
        footer: {
          slogan: '耀雪冰雪世界 · 心梦旅途 激情雪域',
          hotlineLabel: '景区热线：',
        },
        rowLabels: {
          entry: '入园时间',
          validEntry: '有效入园时间',
          ticketEntryExit: '门票出入规则',
          purchaseRule: '购买规则',
          refund: '退款规则',
          rentalRule: '租赁物规则',
          audience: '适用人群',
          verify: '入园核验规则',
        },
        notices: {
          default: '注意：详细规则以景区最新公告为准',
        },
        yuXue: {
          c0: {
            name: '提前订-2026娱雪标准票(线下)不限人群',
            entry: '2026/3/5-2026/12/31，购买成功会有短信通知，并且有专属客服与您沟通入园日期，指定日期入园。客服电话',
            validEntry: '运营时间段内入园',
            ticketEntryExit: '娱雪区域1日多次出入权限',
            purchaseRule: '至少提前一天购买，1张起订',
            refund: '过期随时退',
            rentalRule: '娱雪租赁物单日单次租赁',
            audience: '不限人群',
            verify: '人脸/身份证',
          },
          c1: {
            name: '随买随用-2026娱雪优待票（60周岁以上或3周岁以上11周岁以下儿童）线下',
            entry: '2026/3/5-2026/12/31，购买成功会有客服与您沟通入园日期',
            validEntry: '运营时间段内入园',
            ticketEntryExit: '娱雪区域1日多次出入权限',
            purchaseRule: '随买随用',
            refund: '过期随时退',
            rentalRule: '娱雪租赁物单日单次租赁',
            audience: '1、儿童：1M&lt;身高≤1.4M或3周岁≤年龄≤11周岁的儿童（儿童年龄以身份证标注为准）（需由一名购票成人陪同方能入园）；<br>2、老人：年龄60周岁及以上游客',
            verify: '人脸/身份证',
          },
        },
        huaXue: {
          c0: {
            name: '提前订-2026滑雪初级道3小时标准票(线下)不限人群',
            entry: '平峰时间2026/3/5-2026/12/31其中2026/5/1-2026/10/7为高峰时间，购买成功会有短信通知，并且有专属客服与您沟通入园日期，指定日期入园。客服电话',
            validEntry: '运营时间段内入园',
            ticketEntryExit: '滑雪区域单日不限次出入权限',
            purchaseRule: '至少提前一天购买，1张起订',
            refund: '过期随时退',
            rentalRule: '娱雪租赁物单日单次租赁',
            audience: '不限人群',
            verify: '人脸/身份证',
          },
          c1: {
            name: '提前订-2026滑雪中高级道4小时标准票(线下)不限人群',
            entry: '平峰2026/3/5-2026/12/31其中2026/5/1-2026/10/7为高峰时间，购买成功会有短信通知，并且有专属客服与您沟通入园日期，指定日期入园。客服电话',
            validEntry: '运营时间段内入园',
            ticketEntryExit: '滑雪区域单日不限次出入权限',
            purchaseRule: '至少提前一天购买，1张起订',
            refund: '过期随时退',
            rentalRule: '滑雪租赁物单日单次租赁',
            audience: '不限人群',
            verify: '人脸/身份证',
          },
          c2: {
            name: '提前订-2026滑雪中高级道不限时标准票(线下)不限人群',
            entry: '平峰2026/3/5-2026/12/31其中2026/5/1-2026/10/7为高峰时间，购买成功会有短信通知，并且有专属客服与您沟通入园日期，指定日期入园。客服电话',
            validEntry: '运营时间段内入园',
            ticketEntryExit: '滑雪区域单日不限次出入权限',
            purchaseRule: '至少提前一天购买，1张起订',
            refund: '过期随时退',
            rentalRule: '滑雪租赁物单日单次租赁',
            audience: '不限人群',
            verify: '人脸/身份证',
          },
        },
      },
    },
  },
}

